import React, { useState } from "react";
import {
  Button,
  Checkbox,
  Chip,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  makeStyles,
} from "@material-ui/core";
import { Delete, EditIcon, SortIcon } from "../../../../LeftNav/SvgIcons";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { TooltipDescription } from "../../../../../../components/common/Modal/AssetsModals";
import TagsOverlay from "../../../ConversationsRevamp/TagsOverlay";
import { faqsActions } from "../../../../../../store/faq/faqActions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

const useStyles = makeStyles(theme => ({
  selectedItems: {
    textAlign: "right",
    color: "#8D99A5",
    fontSize: "14px",
    fontWeight: "400",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  gridTable: {
    margin: "20px 0px",
  },
  gridHeaderInner: {
    color: "#A9B2BC",
    fontSize: "12px",
    fontWeight: "700",
    paddingTop: "16px",
    paddingBottom: "16px",
  },
  gridHeaderInnerCenter: {
    color: "#A9B2BC",
    fontSize: "12px",
    fontWeight: "700",
    paddingTop: "4px",
    paddingBottom: "4px",
    textAlign: "center",
  },
  gridBodyInner: {
    color: "#464E5F",
    fontSize: "14px",
    fontWeight: "400",
    paddingTop: "16px",
    paddingBottom: "16px",
  },
  gridBodyInnerCenter: {
    color: "#464E5F",
    fontSize: "14px",
    fontWeight: "400",
    paddingTop: "16px",
    paddingBottom: "16px",
    textAlign: "center",
  },
  gridHeader: {
    background: "#E5F2FF",
    borderRadius: "6px",
  },
  gridHeaderRow: {
    borderRadius: "6px",
  },
  gridIconCells: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "15px",
    "& span": {
      cursor: "pointer",
    },
    csvFile: {
      marginTop: "10px",
      display: "flex",
      justifyContent: "flex-end",
    },
  },
  actionButtons: {
    padding: "unset",
    "&:hover": {
      backgroundColor: "transparent",
      boxShadow: "none",
    },
  },
  gridBodyInnerAction: {
    color: "#A9B2BC",
    fontSize: "12px",
    fontWeight: "700",
    paddingTop: "16px",
    paddingBottom: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    marginRight: "30px",
    cursor: "pointer",
  },
  gridBodyInnerPlatefrom: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  gridHeaderInnerPlatform: {
    textAlign: "center",
  },
  deleteItems: {
    marginBottom: "10px",
  },
}));

const priorityList = [
  { label: "Highest", value: 1 },
  { label: "High Medium", value: 2 },
  { label: "Medium", value: 3 },
  { label: "Low Medium", value: 4 },
  { label: "Lowest", value: 5 },
];

const FAQuesGrid = ({ faqsData, onOrderBy, order, onDeleteFaq }) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const maxVisible = 3;
  const { selectedFaqs } = useSelector(state => state.FaqReducer);

  const redirectUrl = item => {
    history.push(`/new-faq/${item.id}`);
  };

  const onItemSelectAll = () => {
    if (!selectedFaqs?.length) {
      dispatch(faqsActions.selectAllFaqs(faqsData));
    } else {
      dispatch(faqsActions.selectAllFaqs([]));
    }
  };

  const selectFAQs = value => {
    dispatch(faqsActions.selectFaq(value));
  };

  const checkFAQsSelected = itemId => {
    const faqsExist = selectedFaqs?.find(faq => {
      return faq.id === itemId;
    });
    if (faqsExist) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Paper>
      <Paper>
        {selectedFaqs?.length > 0 && (
          <Grid item md={9} className={"tableGridActions"}>
            <Button
              className={classes.deleteItems}
              onClick={() => {
                const deletedIds = selectedFaqs.map(x => x.id);
                console.log("deletedIds**", deletedIds);
                onDeleteFaq(deletedIds);
              }}>
              Delete
            </Button>
          </Grid>
        )}
      </Paper>
      <Table>
        <TableHead className={classes.gridHeader}>
          <TableRow className={classes.gridHeaderRow}>
            <TableCell className={classes.gridHeaderInner}>
              <Checkbox
                className={classes.checkBoxFont}
                checked={
                  selectedFaqs?.length > 0 &&
                  selectedFaqs?.length === faqsData.length
                }
                onChange={onItemSelectAll}
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInner}>
              Category Name
              <TableSortLabel
                active={order.orderByKey === "CategoryName"}
                direction={order.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "CategoryName",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInner}>
              Question
              <TableSortLabel
                active={order.orderByKey === "Question"}
                direction={order.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "Question",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInner}>
              Priority
              <TableSortLabel
                active={order.orderByKey === "Priority"}
                direction={order.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "Priority",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInner}>
              Created On
              <TableSortLabel
                active={order.orderByKey === "CreatedOn"}
                direction={order.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "CreatedOn",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell
              className={`${classes.gridHeaderInner} ${classes.gridHeaderInnerPlatform}`}>
              Platform(s)
            </TableCell>
            <TableCell
              className={
                (classes.gridHeaderInner, "quickLinkWrapper quickLinkHeader")
              }>
              Quick Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {faqsData?.map(item => {
            return (
              <TableRow
                key={item.userId}
                className={`gridBodyRow endUserRow ${
                  selectedFaqs?.length > 0 &&
                  selectedFaqs?.includes(item.userId)
                    ? "boxChecked"
                    : " "
                }`}>
                <TableCell className={`${classes.gridBodyInner}`}>
                  <Checkbox
                    checked={checkFAQsSelected(item.id)}
                    onChange={() => selectFAQs(item)}
                  />
                </TableCell>
                <TableCell
                  className={(classes.gridBodyInner, "capitalize-first")}>
                  {item.categoryName}
                </TableCell>
                <TableCell
                  className={
                    (classes.gridBodyInner,
                    "tableItemHighlight",
                    "capitalize-first")
                  }>
                  <TooltipDescription
                    title={
                      <TagsOverlay
                        title='Question'
                        noChipText='No Question Found'
                        tags={[]}
                        text={item.question}
                      />
                    }
                    placement={"bottom"}>
                    <span>
                      {item.question.length <= 40
                        ? item.question
                        : `${item.question.substring(0, 40)}...`}
                    </span>
                  </TooltipDescription>
                  {/* {item?.question || "--"} */}
                </TableCell>
                <TableCell
                  className={(classes.gridBodyInner, "lastLoginWrapper")}>
                  {priorityList.find(x => x.value === item.priority)?.label ??
                    "--"}
                </TableCell>
                <TableCell
                  className={(classes.gridBodyInner, "lastLoginWrapper")}>
                  {item.createdOn !== null && item.createdOn !== ""
                    ? moment(item.createdOn).format("MMMM DD, YYYY")
                    : "--"}
                </TableCell>
                <TableCell>
                  <div className={classes.gridBodyInnerPlatefrom}>
                    {item.platForm?.length > 0 ? (
                      <>
                        {item.platForm
                          ?.slice(0, maxVisible)
                          ?.map((platform, index) => (
                            <>
                              {platform !== "" && (
                                <Chip
                                  key={index}
                                  label={platform}
                                  style={{ margin: "2px" }}
                                />
                              )}
                            </>
                          ))}
                        {item?.platForm.length > maxVisible && (
                          <TooltipDescription
                            title={
                              <TagsOverlay
                                title='FAQs Platforms'
                                noChipText='No FAQs Platforms  Added'
                                tags={
                                  item?.platForm
                                    ?.slice(maxVisible)
                                    ?.map(x => ({ tag: x })) || []
                                }
                              />
                            }
                            placement={"right-start"}>
                            <span>
                              <Chip
                                label={`+${item.platForm?.length - maxVisible}`}
                                style={{ margin: "2px", cursor: "pointer" }}
                              />
                            </span>
                          </TooltipDescription>
                        )}
                      </>
                    ) : (
                      "--"
                    )}
                  </div>
                </TableCell>

                <TableCell className={classes.gridBodyInnerAction}>
                  <span onClick={() => redirectUrl(item)}>
                    <EditIcon />
                  </span>
                  <span onClick={() => onDeleteFaq([item?.id])}>
                    <Delete />
                  </span>
                </TableCell>
              </TableRow>
            );
          })}
          {faqsData?.length <= 0 && (
            <TableRow key='0' className='gridBodyRow'>
              <TableCell
                colSpan='7'
                className={classes.gridBodyInner}
                style={{ textAlign: "center" }}>
                <span className='emptyGridText'>
                  Uh Oh! You haven’t created any FAQ.
                </span>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default FAQuesGrid;
